<template>
    <v-select
            :value="value"
            :label="data && data.NAME ? data.NAME : 'Select an option'"
            :items="dropdownOptions"
            item-value="value"
            item-text="text"
            @change="emitSelection"
            dense
    >
        <template v-slot:selection="{ item }">
            <div class="d-flex align-center">
                <span class="color-circle" :style="{ backgroundColor: '#' + item.color }"></span>
                {{ item.text }}
            </div>
        </template>

        <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-bind="attrs" v-on="on">
                <v-list-item-content class="d-flex align-center">
                   <span
                           :style="{
              backgroundColor: '#' + item.color,
              padding: '3px 6px',
              color: '#fff',
              borderRadius: '4px'
            }"
                   >
            {{ item.text }}
          </span>
                </v-list-item-content>
            </v-list-item>
        </template>
    </v-select>
</template>

<style scoped>
    .color-circle {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        display: inline-block;
        margin-right: 8px;
        margin: 10px;
    }
</style>

<script>
    export default {
        name: "aedLabelSelect",
        props: {
            data: Object,
            // 🚀 WICHTIG: value Prop definieren
            value: String
        },
        computed: {
            dropdownOptions() {
                if (!this.data || !this.data.OPTIONS) return [];
                return Object.entries(this.data.OPTIONS).map(([key, value]) => ({
                    value: key,
                    text: value.TEXT, 
                    color: value.COLOR 
                }));
            }
        },
        methods: {
            emitSelection(selectedValue) {
                this.$emit("input", selectedValue);
            }
        }
    };
</script>